/** MUI */
import { alpha, Skeleton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    skeleton: {
        backgroundColor: alpha(theme.palette.primary.light, 0.075),
    },
}));

const ChartSkeleton = (props) => {
    const { chartHeight } = props;
    const classes = useStyles();
    return (
        <>
            <Skeleton
                sx={{ height: chartHeight || 190 }}
                width="100%"
                animation="wave"
                variant="rectangular"
                className={classes.skeleton}
            />
        </>
    );
};

export default ChartSkeleton;
